<template>
  <div class="simple-search searchbox-style">
    <input :value="value" @input="onInput($event.target.value)" type="text" :placeholder="placeholder" @keydown="onKeyDown">
    <img class="search-icon" :src="require(`images/project/search-icon.svg`)" alt="search icon">
    <img v-show="value" class="close-icon" :src="require(`images_base/close.svg`)" alt="close icon" @click="onClear">
    <div ref="dropdown" class="simple-dropdown-container" v-if="expand">
      <p :class="matchedInputClass(l)" v-for="(l, i) in suggestions" :key="i" v-html="formatText(l.renderText)" @click="onSelect(l)"></p>
    </div>
  </div>
</template>

<script>
import {getMatchedConstituencyNames} from './SearchConstituency'
import {store} from '../store-constituency'

const rect = el => el && Object.keys(el).length
  ? el.getBoundingClientRect()
  : null

const [UP, DOWN, ENTER] = [38, 40, 13]

const DUMMY_SUGGESTIONS = []
const searched_ref = {}

const year = 2020

export default {
  props: ['dontMakeMeType', 'placeholder'],
  data () {
    return {
      value: '',
      minLength: 1,
      expand: false,
      suggestions: DUMMY_SUGGESTIONS,
      hoverIndex: -1
    }
  },
  computed: {
    currentHoverInput () {
      return this.suggestions[this.hoverIndex] || null
    },
    constituencies () {
      return Object.keys(store.constituencies)
        .map(constituencyName => ({name: constituencyName, renderText: constituencyName}))
    }
  },
  mounted () {
    document.addEventListener('keydown', this.onDocumentKeyDown)
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this.onDocumentKeyDown)
  },
  methods: {
    formatText (text) {
      return text.replace(new RegExp(this.value, 'ig'), match => `<strong>${match}</strong>`)
    },
    onInput (val) {
      this.value = val
      this.handleInput(val)
    },
    onSelect (input) {
      if (!input.name) {
        this.$emit('select', null)
      } else {
        this.$emit('select', input)
      }
      this.hoverIndex = -1
      this.expand = false
      if (input) {
        this.value = input.name
      }
    },
    onClear () {
      this.onSelect({name: ''})
    },
    matchedInputClass (input) {
      return {
        'matched-item': true,
        hovered: this.currentHoverInput === input
      }
    },
    handleInput (value) {
      if (value.length >= this.minLength) {
        if (!isNaN(value) && value.toString().length === 6) { // poster code
          if (searched_ref[value.trim()]) {
            const constituencyName = searched_ref[value.trim()]
            this.suggestions = [
              {renderText: constituencyName, name: constituencyName}
            ]
            this.expand = this.suggestions.length > 0
            this.hoverIndex = this.suggestions.length > 0 ? 0 : -1
          } else {
            fetch(`https://developers.onemap.sg/commonapi/search?searchVal=${value.trim()}&returnGeom=Y&getAddrDetails=Y&pageNum=1`)
            .then(res => res.json())
            .then(({results}) => {
              const newResultRequests = results.map(({LATITUDE, LONGITUDE}) => {
                const endpoint = `https://api.st-visuals.com/election/development/get/constituency?lat=${LATITUDE}&lon=${LONGITUDE}&year=${year}`
                return fetch(endpoint).then(res => res.json())
              })

              Promise.all(newResultRequests)
                .then(addresses => {
                  const constituencyObj = addresses.reduce((acc, cObj) => {
                    searched_ref[value.trim()] = cObj[`GE ${year}`]
                    acc[cObj[`GE ${year}`]] = true
                    return acc
                  }, {})
                  this.suggestions = Object.keys(constituencyObj).map(constituencyName => ({
                    renderText: constituencyName,
                    name: constituencyName
                  }))

                  this.expand = this.suggestions.length > 0
                  this.hoverIndex = this.suggestions.length > 0 ? 0 : -1
                })
            }).catch(err => console.log(err))
          }

        } else { // constituency name
          const suggestedConstituencyNames = getMatchedConstituencyNames(this.constituencies, value)
          this.suggestions = suggestedConstituencyNames.length > 0
            ? suggestedConstituencyNames
            : DUMMY_SUGGESTIONS
          this.expand = this.suggestions.length > 0
        }
      } else {
        this.suggestions = DUMMY_SUGGESTIONS
        this.expand = this.suggestions.length > 0
      }
    },
    onDocumentKeyDown (e) {

    },
    onKeyDown (e) {
      switch (e.keyCode) {
        case ENTER:
          if (this.currentHoverInput) {
            this.onSelect(this.currentHoverInput)
          }
          break
        case UP:
          this.hoverIndex = this.hoverIndex <= 0 ? this.suggestions.length - 1 : --this.hoverIndex
          this.$nextTick(() => this.checkScrollPosition())
          e.preventDefault()
          break
        case DOWN:
          this.hoverIndex = this.hoverIndex === this.suggestions.length - 1 ? 0 : ++this.hoverIndex
          this.$nextTick(() => this.checkScrollPosition())
          e.preventDefault()
          break
      }
    },
    checkScrollPosition () {
      // const dropdownEl = this.$refs.dropdown
      // const currentPos = rect(dropdownEl.querySelectorAll('.hovered')[0])
      // const scrollPanelRect = rect(dropdownEl)
      //
      // const curTop = dropdownEl.scrollTop + currentPos.top
      // const curBottom = dropdownEl.scrollTop + currentPos.bottom
      // const scrollPanelTop = dropdownEl.scrollTop + scrollPanelRect.top
      // const scrollPanelBottom = scrollPanelTop + scrollPanelRect.height
      // if (curBottom > scrollPanelBottom) {
      //   const diff = curBottom - scrollPanelBottom
      //   dropdownEl.scrollTop += diff
      // } else if (curTop < scrollPanelTop) {
      //   const diff = scrollPanelTop - curTop
      //   dropdownEl.scrollTop -= diff
      // }
    }
  }
}
</script>

<style lang="scss">
.searchbox-style {
  width: 100%;

  input[type="text"] {
    box-sizing: border-box;
    width: 100%;
    padding: .4rem 1.8rem .4rem .7rem;
    padding-left: 35px;
    border-radius: 8px;
    border: 1px solid rgba(51, 51, 51, 0.8);
    font-family: $font-CuratorRegular;
    font-size: 14px;
    line-height: 1.3;
    color: $black;
    outline: none;

    &::placeholder {
      opacity: 0.75;
    }
  }

  .simple-dropdown-container {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-height: 150px;
    overflow-y: scroll;
    margin-top: 5px;
    border: 1px solid $black;
    border-radius: 8px;
    background-color: #FFFFFF;
    z-index: 1;

    &:empty {
      border: none;
    }

    .matched-item {
      cursor: pointer;
      font-family: $font-CuratorRegular;
      font-size: 16px;
      line-height: 1.3;
      padding: 5px 10px;
      padding-right: 40px;
      text-align: left;

      strong {
        font-family: $font-CuratorBold;
      }

      &.hovered,
      &:hover {
        background-color: #3f8dd6;
        color: #FFFFFF;
      }
    }
  }
}

.simple-search {
  position: relative;

  img.search-icon {
    position: absolute;
    left: 10px;
    top: 10px;
    height: 1rem;
  }
  img.close-icon {
    position: absolute;
    right: 7px;
    top: 12px;
    height: 0.7rem;
    opacity: 0.5;
    cursor: pointer;
  }
}
</style>
